import { useQuery } from '@tanstack/react-query';

import { GET_EVIDENCE_INTEGRATIONS } from '../../contracts';
import { getEvidenceIntegrations } from '../api/evidenceIntegrations';
import { useIsAuthenticated } from '../injected';

export function useQueryEvidenceIntegrations({ enabled }: { enabled: boolean }) {
  const isAuthenticated = useIsAuthenticated();

  return useQuery({
    queryKey: [GET_EVIDENCE_INTEGRATIONS],
    enabled: enabled && isAuthenticated,
    queryFn: async () => {
      const { data } = await getEvidenceIntegrations();
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
